import { createSelector } from '@reduxjs/toolkit';
export const notificationsReducer = (state) => state.reduxNotifications;
export const notificationsSelector = createSelector(notificationsReducer, (reducer) => {
    return reducer.data.toSorted((a, b) => Date.parse(b.actionInst.timestamp) - Date.parse(a.actionInst.timestamp));
});
export const unreadNotificationsCountSelector = createSelector(notificationsReducer, (reducer) => reducer.unreadNotifications);
